import Keycloak from "keycloak-js";

const _kc = new Keycloak('');

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
  document.getElementById("root").innerHTML = `
  <div style="height:100vh; display:flex; flex-direction:column; justify-content:center; align-items:center; background:linear-gradient(135deg, #6a11cb, #2575fc); color:white; font-family:sans-serif;">
    
    <!-- Spinner -->
    <div class="spinner-border text-light mb-3" style="width: 3rem; height: 3rem;" role="status"></div>
    
    <!-- Text -->
    <h3 style="font-weight:600; letter-spacing:1px;">Getting Things Ready For You...</h3>
    <p style="font-size:14px; opacity:0.8; margin-top:8px;">Please wait a moment while we prepare your experience ✨</p>
  </div>
`;

  _kc.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
  })
    .then((authenticated) => {
      if (!authenticated) {
        console.log("user is not authenticated..!");
        sessionStorage.removeItem("error")
      }
      onAuthenticatedCallback(); //render
    })
    .catch(error => {
      onAuthenticatedCallback() //app2
      sessionStorage.setItem("error", "Server Down")
      console.log(error)
    })
};

const doLogin = _kc.login;
const doSignUp = _kc.register;
const doCreateAccount = _kc.createAccount;

const doLogout = _kc.logout;

const getToken = () => _kc.token;
const getSessionId = () => _kc.sessionId;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback) =>
  _kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;
const getFullName = () => _kc.tokenParsed?.name;
const getEmail = () => _kc.tokenParsed?.email;

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const getAccountUrl = () => _kc.createAccountUrl();
const getUpdatePassword = () => _kc.updatePasswordUrl();



const UserService = {
  initKeycloak,
  doLogin,
  doSignUp,
  doLogout,
  doCreateAccount,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  hasRole,
  getFullName,
  getEmail,
  getSessionId,
  getAccountUrl,
  getUpdatePassword
};

export default UserService;
